// common/services/player/searchPlayers.ts
import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

/**
 * A row from GET /search/admin/players. Mirrors the shape the admin player
 * search returns (name, contact, image, and the teams the player belongs to).
 */
export interface AdminPlayerSearchResult {
  id: string
  name_first: string
  name_last: string
  full_name?: string | null
  email: string
  birth_date?: string | null
  height?: string | null
  weight?: string | null
  image?: unknown
  teams?: Array<{
    id: string
    name: string
    sport?: string
    organization?: string
  }>
  [key: string]: unknown
}

export interface SearchAdminPlayersArgs {
  query: string
  /**
   * Scope params resolved by the caller (SN-7578 lives in the hook):
   * - both omitted → true global search (Canlan / true-global tenants),
   * - `organizationId` + `accountId` → account-scoped broaden,
   * - `organizationId` only → org-scoped (default / fallback).
   */
  organizationId?: string
  accountId?: string
  page?: number
}

/**
 * GET /search/admin/players — admin player search used by the roster "Add
 * Player" box. Sends whichever scope params the caller provides; each param is
 * omitted when undefined so the request hits the right (global / account / org)
 * branch. The tenant policy for what to send lives in usePlayerSearch.
 */
export const searchAdminPlayers = async ({
  query,
  organizationId,
  accountId,
  page = 1,
}: SearchAdminPlayersArgs): Promise<AdminPlayerSearchResult[]> => {
  const response = await req(ENDPOINTS.SEARCH.ADMIN_PLAYERS(), {
    method: 'GET',
    query: {
      page,
      query,
      // undefined → query builder drops the param.
      organization_id: organizationId,
      account_id: accountId,
    },
  })
  return (response?.data as AdminPlayerSearchResult[]) ?? []
}
